import { parsePhoneNumber } from '../node_modules/.pnpm/libphonenumber-js@1.12.22/node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js';

const formatPhoneNumber = (phone, locale = "US") => {
    if (!phone)
        return "";
    try {
        const phoneNumber = parsePhoneNumber(phone, locale);
        if (!phoneNumber)
            return phone;
        // Format as national number (e.g. (555) 555-5555) if it's a US number
        // Otherwise use international format (e.g. +1 555 555 5555)
        return phoneNumber.country === "US"
            ? phoneNumber.formatNational()
            : phoneNumber.formatInternational();
    }
    catch {
        // If parsing fails, return the original string
        return phone;
    }
};

export { formatPhoneNumber };
//# sourceMappingURL=phone.js.map
